import { Component, inject, input, output } from '@angular/core';
import { ImagesService } from '../../../../services/general/images.service';
import { Category } from '../../../../interfaces/responses/category.interface';
import { DatePipe, CommonModule } from '@angular/common';
import { CategoryService } from '../../../../services/categories/category.service';
import { ToastService } from '../../../../services/general/toast.service';
import { ConfirmationDialogComponent } from '../../../shared/confirmation-dialog/confirmation-dialog.component';
import { PermissionService } from '../../../../services/permission/permission.service';

@Component({
  selector: 'app-category-table',
  imports: [
    CommonModule,
    DatePipe,
    ConfirmationDialogComponent
  ],
  templateUrl: './category-table.component.html',
  styleUrl: './category-table.component.scss'
})
export class CategoryTableComponent {
  _images = inject(ImagesService);
  permissionService = inject(PermissionService);
  categoryService = inject(CategoryService);
  _toast = inject(ToastService);
  isUpdateCategory = input<boolean>(true);
  showDeleteDialog: boolean = false;
  showStatusDialog: boolean = false;
  isActionClick: boolean = false;

  onActionClick() {
    this.isActionClick = !this.isActionClick;
  }

  category = input<Category>();

  showDeleteConfirmation() {
    this.showDeleteDialog = true;
  }

  cancelDelete() {
    this.showDeleteDialog = false;
  }

  confirmDelete() {
    const id = this.category()?.id;
    if (!id) {
      console.error('Category ID is undefined. Cannot delete category.');
      return;
    }

    this.categoryService.deleteCategory(id).subscribe({
      next: (response) => {
        this._toast.success('Category deleted successfully');
        this.showDeleteDialog = false;
        this.loadCategoryData();
      },
      error: (error) => {
        console.error('Error deleting category:', error);
        this._toast.error('Error deleting category');
        this.showDeleteDialog = false;
      }
    });
  }

  loadCategoryEvent = output<void>()
  loadCategoryData() {
    this.loadCategoryEvent.emit();
  }

  updateCategoryEvent = output<Category>()
  showOverlayEvent = output<void>()

  updateCategory() {
    const category = this.category();
    if (!category) {
      console.error('Category is undefined. Cannot update category.');
      return;
    }
    this.updateCategoryEvent.emit(category);
    this.showOverlayEvent.emit();
  }

  onEditClick() {
    if (!this.permissionService.canManage('categories')) return;
    this.updateCategory();
  }

  onDeleteClick() {
    if (!this.permissionService.canManage('categories')) return;
    this.showDeleteConfirmation();
  }

  onStatusToggleClick() {
    if (!this.permissionService.canManage('categories')) return;
    this.showStatusConfirmation();
  }

  showStatusConfirmation() {
    this.showStatusDialog = true;
  }

  cancelStatusToggle() {
    this.showStatusDialog = false;
  }

  confirmStatusToggle() {
    const id = this.category()?.id;
    if (!id) {
      console.error('Category ID is undefined. Cannot toggle category status.');
      this.showStatusDialog = false;
      return;
    }

    const category = this.category();
    const currentStatus = category?.isActive ?? false;
    const action = currentStatus ? 'deactivated' : 'activated';

    this.categoryService.toggleStatus(id).subscribe({
      next: (response) => {
        this._toast.success(`Category ${action} successfully`);
        this.showStatusDialog = false;
        this.loadCategoryData();
      },
      error: (error) => {
        console.error('Error toggling category status:', error);
        this._toast.error(`Error ${action} category`);
        this.showStatusDialog = false;
      }
    });
  }
}

